<template>
  <div
    class="product-link"
    :class="[variant, isNonClickable && 'disabled']"
    @click="onClick"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    v-bind="attrs"
    v-on="on"
  >
    <v-tooltip bottom :disabled="!tooltip">
      <template v-slot:activator="{ on, attrs }">
        <component
          :id="iconComponent(product)"
          :hovered="hover"
          :active="active"
          :disabled="isIconDisabled"
          :variant="variant"
          :product="id"
          v-bind:is="iconComponent(product)"
          v-bind="attrs"
          v-on="on"
        ></component>

        <div class="d-inline-flex flex-column ml-2" v-bind="attrs" v-on="on">
          <p v-if="wip" class="mb-0 product-link-subtitle">Coming soon</p>
          <p class="product-link-name mb-0" :class="[isTextDisabled && 'c360-charcoal-gray--text']">
            <span>{{ product }}</span>
          </p>
        </div>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { getIconComponentName, IconSettings } from './model';
  import {
    AnalyticsIcon,
    CompulseOMSIcon,
    HelpCenterIcon,
    InstantIOIcon,
    ManagementReportingIcon,
    MediaPlannerIcon,
    OrdersIconIcon,
    PlacementsIOIcon,
    CreativeGalleryIcon,
  } from './ui';

  export default Vue.extend({
    name: 'C360ProductLink',

    components: {
      analytics: AnalyticsIcon,
      'compulse-oms': CompulseOMSIcon,
      'help-center': HelpCenterIcon,
      'instant-io': InstantIOIcon,
      'management-reporting': ManagementReportingIcon,
      'media-planner': MediaPlannerIcon,
      orders: OrdersIconIcon,
      'placements-io-oms': PlacementsIOIcon,
      'creative-gallery': CreativeGalleryIcon,
    },

    props: {
      /**
       * Product id to which link should redirect.
       */
      id: {
        type: String,
        required: true,
      },
      /**
       * Product to which link should redirect.
       */
      product: {
        type: String,
        required: true,
      },

      /**
       * Indicates if this product is the current one.
       */
      active: {
        type: Boolean,
        default: false,
      },

      /**
       * Indicates if this product is not available now but WIP.
       */
      wip: {
        type: Boolean,
        default: false,
      },

      /**
       * Indicates if this product is not available for user but not in progress.
       */
      disabled: {
        type: Boolean,
        default: true,
      },
      /**
       * Tooltip for the link.
       */
      tooltip: {
        type: String,
        default: '',
      },

      /**
       * A variant of the link, must be one of
       * @type {'normal' | 'small'}
       */
      variant: {
        type: String,
        default: 'normal',
      },
    },

    data() {
      return {
        hover: false,
      };
    },

    computed: {
      /**
       * Indicates if this link is not clickable.
       */
      isNonClickable() {
        return this.active || this.wip || this.disabled || !!this.tooltip;
      },

      isIconDisabled() {
        return this.wip || this.disabled || !!this.tooltip;
      },

      iconColorSettings() {
        return IconSettings[this.product];
      },
      isTextDisabled() {
        return this.wip || this.disabled || !!this.tooltip;
      },
    },

    methods: {
      iconComponent(product) {
        return getIconComponentName(product.toLowerCase());
      },
      onClick() {
        if (this.isNonClickable) return;
        this.$emit('click');
      },
    },
  });
</script>

<style scoped>
  .product-link {
    cursor: pointer;
    font-family: var(--c360-font);
    display: flex;
    align-items: center;
  }

  .product-link.disabled {
    cursor: default;
  }

  .product-link.normal {
    display: flex;
    align-items: center;
  }

  .product-link-name {
    font-weight: 600;
    text-transform: uppercase;
  }

  .normal .product-link-name {
    font-size: 12px;
  }
  .small .product-link-name {
    font-size: 10px;
  }

  .product-link-name span {
    white-space: break-spaces;
  }

  .product-link-subtitle {
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
  }
</style>
